import React from 'react';
import '../styles/chat.css';
import { useContext, useState, useEffect } from 'react';
import filterContext from '../context/filters/filterContext';
import { Puff } from 'react-loader-spinner';
import ChatDetail from './ChatDetails';
import { useSelector } from 'react-redux';
// import { apiBaseUrl } from 'utils/config';
import moment from 'moment';

function Chat({
	pp,
	contact,
	msg,
	time,
	unread,
	cID,
	descriptionn,
	usersOfThatGroup,
	isRedFlag,
	isSend,
	setIsSend,
	createdByObj,
	createdAtTime,
	lastMessage,
	lastMsgTime,
	mentionedIds,
}) {
	const { setnamePerson, setpimgLink, description, setdescription } = useContext(
		filterContext
	);
	const {
		getMsg,
		fetchChatConversation,
		usersOfParticularGroup,
		setusersOfParticularGroup,
		setSenderId,
		setSenderName,
	} = useContext(filterContext);

	const [active, setActive] = useState('');
	const {
		conversationId,
		setconversationId,
		settogChat,
		convId,
		setconvoId,
		setUnreadFlag,
		fetchConversation,
		setDisplayedUsersOfGroup,
		displayedUsersOfGroup,
		setAdminsOfParticularGrp,
		adminsOfParticularGrp,
		setIsGroupEdited,
		setForwardCheckbox,
		setSelectedFiles,
		setPreviewURLs,
		isChatOpen,
		setIsChatOpen,
		setselectedFilesPdf,
		setSelectedMsgs,
		setSelectedReceivedMsgs,
		readConversationByUSer,
		setIsPollMsgSelected,
		createdBy,
		setCreatedBy,
		createdAt,
		setCreatedAt,
		setSelectedRedFlagMsgs,
		showPopupClip,
		setShowPopupClip,
		setSelectedMsgsForForward,
		setSelectedMsgsForDelete,
		olderMessages,
		setOlderMessages,
		lastchat,
		setLastchat,
	} = useContext(filterContext);
	Chat.defaultProps = {
		pp:
			'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/628c8d587640243d911a71d4/kbVumlrcT6.svg',
	};
	const { reloadFlag, setReloadFlag } = useContext(filterContext);
	useEffect(() => {
		setReloadFlag(false);
	}, [reloadFlag]);

	//get user data from redux store
	const userSelector = state => state.user;
	const user = useSelector(userSelector);

	function handlechat(chat) {
		setIsChatOpen(true);
		setUnreadFlag(false);
		setOlderMessages(true);
		readConversationByUSer(cID);
		setSenderId(user._id);
		setSenderName(user.name);
		setnamePerson(contact);
		setpimgLink(pp);
		setconvoId(cID);
		settogChat(true);
		fetchChatConversation(cID);
		setdescription(descriptionn);
		setCreatedBy(createdByObj);
		setCreatedAt(createdAtTime);
		setusersOfParticularGroup(usersOfThatGroup);
		fetchConversation();
		setDisplayedUsersOfGroup([]);
		setIsGroupEdited(false);
		setForwardCheckbox(false);
		setSelectedFiles([]);
		setPreviewURLs([]);
		setselectedFilesPdf([]);
		setIsChatOpen(true);
		setSelectedMsgsForForward([]);
		setSelectedMsgsForDelete([]);
		setSelectedReceivedMsgs([]);
		setIsPollMsgSelected([]);
		setSelectedRedFlagMsgs([]);
		setShowPopupClip(false);
		setLastchat(true);
	}

	const formatDateAndTime = utcTime => {
		const currentDate = moment();
		const yesterdayDate = moment().subtract(1, 'day');
		if (moment(utcTime).isSame(currentDate, 'day')) {
			return moment(utcTime)
				.locale('en-in')
				.format('hh:mm A');
		} else if (moment(utcTime).isSame(yesterdayDate, 'day')) {
			return 'Yesterday';
		} else {
			return moment(utcTime).format('DD/MM/YYYY');
		}
	};

	return (
		<>
			{/* // Chat container */}
			<div
				onClick={handlechat}
				className={`chat-container ${active ? 'active-bg' : ''} ${isRedFlag ? 'red-flag' : ''
					}`}
			>
				{/* Profile picture */}
				
				{pp ? <img className="profile-pic" src={pp} alt="profile pic" /> : <Puff visible={true}
					height="50"
					width="50"
					color="yellow"
					ariaLabel="puff-loading" />}
				{/* Info container */}
				<div className="info-container">
					{/* Contact name and msg */}
					<div className="contact-info">
						{/* Contact name */}
						<h6
							style={{
								marginBottom: `${lastMessage ? '2px' : '4px'}`,
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
								overflow: 'hidden',
							}}
							className="contact-name"
						>
							{contact}
						</h6>
						<p
							style={{
								color: `${unread == 0 ? '#8696A0' : '#e4e4e4'}`,
								fontSize: '0.9rem',
								textOverflow: 'ellipsis',
								whiteSpace: 'nowrap',
								// overflow: 'hidden',
							}}
						>
							{lastMessage && lastMessage}
						</p>
						{/* msg */}
					</div>
					{/* Time and Number of msgs */}
					<div className="time-msg-info">
						{/* Time  */}
						{lastMsgTime && (
							<p
								className="msg-time"
								style={{ color: `${unread == 0 ? '#8696A0' : 'rgb(16 185 129)'}` }}
							>
								{formatDateAndTime(lastMsgTime)}
							</p>
						)}
						{/* Number of msgs */}
						{/* {unreadMsgs && ( */}
						<div style={{ display: 'flex' }}>
							{mentionedIds.length > 0 && mentionedIds.includes(user._id) && (
								<p
									style={{
										color: 'rgb(16 185 129)',
										fontWeight: '700',
										fontSize: '16px',
										marginRight: '5px',
									}}
								>
									@
								</p>
							)}
							{unread != 0 && unread != undefined ? (
								<div className="number-of-msgs">
									<p className={`${!unread ? 'unread-msg' : 'read-msg'}`}>{unread}</p>
								</div>
							) : (
								<div></div>
							)}
						</div>
					</div>
				</div>
			</div>
		</>
	);
}

export default Chat;
